import { FC } from 'react';
import { Skeleton, Stack } from '@mui/material';

const OptionSkeleton: FC = () => (
	<Stack gap={2}>
		{/* Title */}
		<Skeleton variant="text" width="70%" height={28} />
		{/* Description - multiple lines */}
		<Stack gap={0.5}>
			<Skeleton variant="text" width="100%" height={20} />
			<Skeleton variant="text" width="90%" height={20} />
		</Stack>
		{/* Button */}
		<Skeleton variant="rounded" width="100%" height={48} />
	</Stack>
);

export const DTicketSubscriptionEditSkeleton: FC = () => {
	return (
		<Stack gap={3}>
			{/* First Option */}
			<OptionSkeleton />

			{/* Divider */}
			<Stack direction="row" alignItems="center" gap={2}>
				<Skeleton variant="text" width="45%" height={1} />
				<Skeleton variant="text" width="10%" height={20} />
				<Skeleton variant="text" width="45%" height={1} />
			</Stack>

			{/* Second Option */}
			<OptionSkeleton />
		</Stack>
	);
};
